
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

import * as PaymentLoadings from '../../../../constants/loadings/backoffice/payments';
import { PaySummaryTable } from './table';


export const PaySummary = ({ paymentState }) => {

	const options = { style: 'currency', currency: 'EUR' };
	// const [invoiceLinesToPay, setinvoiceLinesToPay] = useState(paymentState.partnerInvoiceLines ? paymentState.partnerInvoiceLines.filter(line => line.billedByPartner === true) : []);
	// const [invoiceLinesToBill, setinvoiceLinesToBill] = useState(paymentState.partnerInvoiceLines ? paymentState.partnerInvoiceLines.filter(line => !line.billedByPartner) : []);
	const [invoiceLinesToDisplay, setInvoiceLinesToDisplay] = useState(paymentState.partnerInvoiceLines ? paymentState.partnerInvoiceLines : []);
	const [totalLinesAmount, setTotalLinesAmount] = useState(paymentState.partnerInvoiceLines ? paymentState.partnerInvoiceLines.reduce((acc, line) => { acc += line.totalPrice; return acc; }, 0) : 0);



	useEffect(() => {

		if (!R.isNil(paymentState.partnerInvoiceLines)) {
			// setinvoiceLinesToPay(paymentState.partnerInvoiceLines.filter(line => line.billedByPartner));
			// setinvoiceLinesToBill(paymentState.partnerInvoiceLines.filter(line => !line.billedByPartner));
			setInvoiceLinesToDisplay(paymentState.partnerInvoiceLines);
			setTotalLinesAmount(paymentState.partnerInvoiceLines.reduce((acc, line) => { acc += line.totalPrice; return acc; }, 0));

		}
	}, [paymentState.partnerInvoiceLines]);



	return (
		<div className="modal fade px-0" id="paySummary" aria-labelledby="paySummaryLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header pb-0">
						<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Payment summary</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="paySummaryLabel">Information du paiement</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body">
						<h2 className="fs-sm ls-n1">Ci-dessous les <strong>lignes associées</strong>  à ce paiement.</h2>
						<div className="fs-3 o-60">Partenaire: Nom du partneaire<i className="eva eva-chevron-right-outline align-middle mx-2 o-50"></i>Établissement: Nom d'établissement </div>
						<div className="bg-light rounded mt-4 p-3">
							{/* <section className="block mb-4">
								<div className="flex-row justify-content-between align-items-center mb-2">
									<h3 className="h6 text-uppercase font-weight-bold mr-2 my-auto">A Payer</h3>
									<button className="btn-icon btn-alert bg-white navbar-toggler border-0 ml-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#trierPayer" aria-controls="trierPayer" aria-expanded="false" aria-label="Toggle navigation">
										<span className="btn-alert-primary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-1"></span>
										<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Trier par</span>
									</button>
								</div>
								<article className="block">
									<nav className="navbar navbar-expand-lg collapse navbar-collapse py-0 px-2 mb-xs" id="trierPayer">
										<div className="flex-column w-100">
											<div className="row g-1 gy-lg-0 align-items-center">
												<div className="col col-lg-2 flex-row">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate text-primary">Modèle</div>
												</div>
												<div className="col col-lg-2 flex-row">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate">Quantité</div>
												</div>
												<div className="col flex-row justify-content-lg-end" role="button">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button" >
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button" >
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate container-tiny">Prix <span className="d-lg-none d-xl-inline-block"> Unitaire</span></div>
												</div>
												<div className="col flex-row justify-content-lg-end" role="button">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate"><span className="d-lg-none d-xl-inline-block">Prix</span> Commission</div>
												</div>
												<div className="col flex-row justify-content-lg-end" role="button">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate"><span className="d-lg-none d-xl-inline-block">Prix</span> Total</div>
												</div>
											</div>
										</div>
									</nav>
									<div className="card p-2 mt-1">
										<div className="row g-1 align-items-center">
											<div className="col col-lg-2 text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">Initial</div>
											</div>
											<div className="col col-lg-2 text-truncate text-right text-lg-left">
												<div className="h5 ls-1 my-auto o-80 text-truncate">9</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0" />
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto o-80 text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
										</div>
									</div>
									<div className="card p-2 mt-1">
										<div className="row g-1 align-items-center">
											<div className="col col-lg-2 text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">Recurrent</div>
											</div>
											<div className="col col-lg-2 text-truncate text-right text-lg-left">
												<div className="h5 ls-1 my-auto o-80 text-truncate">69</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0" />
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto o-80 text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
										</div>
									</div>
								</article>
								<hr className="mb-2" />
								<div className="flex-row justify-content-between align-items-center">
									<h3 className="fs-3 font-weight-bold my-auto">Total</h3>
									<h4 className="h5 my-auto">266,33 €</h4>
								</div>
							</section>
							<section className="block mb-4">
								<div className="flex-row justify-content-between align-items-center mb-2">
									<h3 className="h6 text-uppercase font-weight-bold mr-2 my-auto">A Facturer</h3>
									<button className="btn-icon btn-alert bg-white navbar-toggler border-0 ml-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#trierFacturer" aria-controls="trierPayer" aria-expanded="false" aria-label="Toggle navigation">
										<span className="btn-alert-primary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-1"></span>
										<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Trier par</span>
									</button>
								</div>
								<article className="block">
									<nav className="navbar navbar-expand-lg collapse navbar-collapse py-0 px-2 mb-xs" id="trierFacturer">
										<div className="flex-column w-100">
											<div className="row g-1 gy-lg-0 align-items-center">
												<div className="col col-lg-2 flex-row">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate text-primary">Modèle</div>
												</div>
												<div className="col col-lg-2 flex-row">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate">Quantité</div>
												</div>
												<div className="col flex-row justify-content-lg-end" role="button">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button" >
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button" >
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate container-tiny">Prix <span className="d-lg-none d-xl-inline-block"> Unitaire</span></div>
												</div>
												<div className="col flex-row justify-content-lg-end" role="button">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate"><span className="d-lg-none d-xl-inline-block">Prix</span> Commission</div>
												</div>
												<div className="col flex-row justify-content-lg-end" role="button">
													<div className="flex-column mr-1">
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-up fs-2 lh-0"></i>
														</button>
														<button className="btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline o-50 o-100--hover" type="button">
															<i className="eva eva-arrow-down fs-2 lh-0"></i>
														</button>
													</div>
													<div className="btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate"><span className="d-lg-none d-xl-inline-block">Prix</span> Total</div>
												</div>
											</div>
										</div>
									</nav>
									<div className="card p-2 mt-1">
										<div className="row g-1 align-items-center">
											<div className="col col-lg-2 text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">Initial</div>
											</div>
											<div className="col col-lg-2 text-truncate text-right text-lg-left">
												<div className="h5 ls-1 my-auto o-80 text-truncate">9</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0" />
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto o-80 text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
										</div>
									</div>
									<div className="card p-2 mt-1">
										<div className="row g-1 align-items-center">
											<div className="col col-lg-2 text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">Recurrent</div>
											</div>
											<div className="col col-lg-2 text-truncate text-right text-lg-left">
												<div className="h5 ls-1 my-auto o-80 text-truncate">69</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0" />
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto o-80 text-truncate">formatAmount(invoice.amount) €</div>
											</div>
											<div className="col text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
										</div>
									</div>
								</article>
								<hr className="mb-2" />
								<div className="flex-row justify-content-between align-items-center">
									<h3 className="fs-3 font-weight-bold my-auto">Total</h3>
									<h4 className="h5 my-auto">266,33 €</h4>
								</div>
							</section> */}
							{/* {!paymentState.isLoading.includes(PaymentLoadings.FETCHING_PARTNER_LINES) ?
								<>
									{!R.isEmpty(invoiceLinesToPay) && <PaySummaryTable title="A Payer" id={"payer"} key={"payer"} invoiceLines={invoiceLinesToPay} />}
									{!R.isEmpty(invoiceLinesToBill) && <PaySummaryTable title={"A Facturer"} id={"facturer"} key={"facturer"} invoiceLines={invoiceLinesToBill} />}
									<div className="flex-row justify-content-between align-items-center bg-dim p-xs rounded-sm">
										<h3 className="h6 text-uppercase font-weight-bold my-auto">Revelé</h3>
										<h4 className="h5 my-auto">{new Intl.NumberFormat('fr-FR', options).format(totalLinesAmount)}</h4>
									</div>
								</>
								:
								<div className="d-flex justify-content-center"><div className="spinner-border spinner-border-sm text-primary ml-1" role="status"><span className="sr-only">Loading...</span></div></div>
							} */}
							{!paymentState.isLoading.includes(PaymentLoadings.FETCHING_PARTNER_LINES) ?
								<React.Fragment>

									{<PaySummaryTable title={"A Facturer"} id={"facturer"} invoiceLines={invoiceLinesToDisplay} />}
									{/* <div className="flex-row justify-content-between align-items-center bg-dim p-xs rounded-sm">
										<h3 className="h6 text-uppercase font-weight-bold my-auto">Revelé</h3>
										<h4 className="h5 my-auto">{new Intl.NumberFormat('fr-FR', options).format(totalLinesAmount)}</h4>
									</div> */}
								</React.Fragment>
								:
								<div className="d-flex justify-content-center"><div className="spinner-border spinner-border-sm text-primary ml-1" role="status"><span className="sr-only">Loading...</span></div></div>
							}

						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close">Fermer</button>
						<button type="button" className="btn btn-info">Ok</button>
					</div>
				</div>
			</div>
		</div >
	);
};










